document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-pw-menu-toggle]');
  const nav = document.querySelector('[data-pw-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
});
